<div class="card border-danger">
  <!--the title is passed from the parent component via @input-->
  <div class="card-header bg-danger text-white d-flex align-items-center">
        <i class="glyphicon glyphicon-exclamation-sign mr-2"></i><b>{{title}}</b>
  </div>
  <div class="card-body text-danger">

    <!--general error title/message can be in different places-->
    <ng-container *ngIf="error && error.message">
      <p class="card-title" [innerHTML]="error.message"></p>
    </ng-container>

    <ng-container *ngIf="e; else noErrorDetails">

      <ng-container *ngIf="e.errorMessage">
        <p class="card-text">{{e.errorMessage}}</p>
      </ng-container>

      <ng-container *ngIf="e.title">
        <p class="card-text">{{e.title}}</p>
      </ng-container>

    <!--validation errors will be in an array-->
      <ng-container *ngIf="e.errors">

        <ng-container *ngFor="let vaidationErrorGroup of e.errors | keyvalue">
          <b>{{vaidationErrorGroup.key}}</b>

          <ul>
            <li *ngFor="let e of vaidationErrorGroup.value" class="card-text">{{e}}</li>
          </ul>

        </ng-container>

      </ng-container>

    <!--exceptions have their own property and potentially inner exceptions-->
      <ng-container *ngIf="e.exception">

        <p class="card-text">{{e.exception.message}}</p>

        <p class="card-text">{{e.title}}</p>


        <ng-container *ngIf="e.exception.innerException">

          <button (click)="showInnerException = !showInnerException" class="btn btn-sm btn-danger">{{showInnerException ? 'Show less details' : 'Show more details'}}</button>

          <ng-container *ngIf="showInnerException">

            <hr />

            <p class="card-text">{{e.exception?.innerException?.message}}</p>
            <small class="card-text">Stack Trace: {{e.exception?.innerException?.stackTrace}}</small>
            <small class="card-text">Source: {{e.exception?.innerException?.source}}</small>
          </ng-container>

        </ng-container>

      </ng-container>
    </ng-container>

    <ng-template #noErrorDetails>
      No more details available
    </ng-template>

  </div>
</div>
